import type {SVGProps, FC} from 'react';

export const MessageMinusOutlineIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
    return (
        <svg viewBox='0 0 24 24' fill='currentColor' xmlns='http://www.w3.org/2000/svg' {...props}>
            <path
                d='M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.11 18 22 17.11 22 16V4C22 2.9 21.11 2 20 2ZM20 16H6L4 18V4H20V16ZM8 9V11H16V9H8Z'
            />
        </svg>
    );
};

